import "./index.scss";

export const BalanceItemLabel = ({ label }) => {
  return (
    <div
      className="balance-item-label"
      id={label}
      data-testid={`label-${label}`}
    >
      {label}
    </div>
  );
};
